module.exports = __webpack_public_path__ + "img/white-square.743c6f87.svg";